import { AppShell as Shell, Header, AppShellProps } from "@mantine/core";
import { AppHeader } from "../AppHeader";
import { useLocation } from "react-router-dom";

export const AppShell = ({ children }: AppShellProps) => {
  const location = useLocation();
  console.log(location);

  return (
    <Shell
      fixed
      padding={
        location.pathname === "/modules/endometrial-biopsy/post-module-game"
          ? 0
          : 16
      }
      header={
        location.pathname === "/modules/endometrial-biopsy/post-module-game" ? (
          <></>
        ) : (
          <Header height={70} p="md">
            <AppHeader />
          </Header>
        )
      }
    >
      {children}
    </Shell>
  );
};
